"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationService = void 0;
const request_1 = require("../core/request");
class IntegrationService {
    /**
     * 创建集成应用
     * 创建新的集成应用，支持内部插件和外部应用两种类型
     * @param requestBody
     * @returns any 创建成功
     * @throws ApiError
     */
    static async createIntegrations(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/integrations`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取集成应用列表
     * 获取当前用户创建的所有集成应用
     * @returns any 获取成功
     * @throws ApiError
     */
    static async getIntegrations() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/integrations`,
        });
        return result.body;
    }
    /**
     * 获取空间内所有集成
     * 获取空间内所有集成
     * @param spaceId 空间id
     * @returns any 获取成功
     * @throws ApiError
     */
    static async getSpaceIntegrations(spaceId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/integrations/spaces/${spaceId}/integrations`,
        });
        return result.body;
    }
    /**
     * 获取单个集成的bots
     * 获取单个集成的bots
     * @param integrationId 集成应用ID
     * @returns any 获取成功
     * @throws ApiError
     */
    static async getIntegrationBots(integrationId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/integrations/${integrationId}/bots`,
        });
        return result.body;
    }
    /**
     * 获取单个集成应用
     * 获取指定集成应用的详细信息
     * @param integrationId 集成应用ID
     * @returns any 获取成功
     * @throws ApiError
     */
    static async getIntegration(integrationId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/integrations/${integrationId}`,
        });
        return result.body;
    }
    /**
     * 更新集成应用
     * 更新集成应用的配置信息
     * @param integrationId 集成应用ID
     * @param requestBody
     * @returns any 更新成功
     * @throws ApiError
     */
    static async patchIntegration(integrationId, requestBody) {
        const result = await (0, request_1.request)({
            method: 'PATCH',
            path: `/integrations/${integrationId}`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 删除集成应用
     * 删除指定的集成应用
     * @param integrationId 集成应用ID
     * @returns any 删除成功
     * @throws ApiError
     */
    static async deleteIntegration(integrationId) {
        const result = await (0, request_1.request)({
            method: 'DELETE',
            path: `/integrations/${integrationId}`,
        });
        return result.body;
    }
    /**
     * 获取集成应用密钥
     * 获取集成应用的密钥，用于OAuth认证
     * @param integrationId 集成应用ID
     * @returns any 获取成功
     * @throws ApiError
     */
    static async getIntegrationSecret(integrationId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/integrations/${integrationId}/secret`,
        });
        return result.body;
    }
    /**
     * 重置集成应用密钥
     * 重新生成集成应用的密钥
     * @param integrationId 集成应用ID
     * @returns any 重置成功
     * @throws ApiError
     */
    static async patchIntegrationSecret(integrationId) {
        const result = await (0, request_1.request)({
            method: 'PATCH',
            path: `/integrations/${integrationId}/secret`,
        });
        return result.body;
    }
    /**
     * 获取授权页面信息
     * 获取用于渲染授权页面的信息，包括集成应用信息和用户空间列表
     * @param clientId 集成应用ID
     * @param redirectUri 重定向URI
     * @param scope 权限范围
     * @param state 状态参数
     * @returns any 获取成功
     * @throws ApiError
     */
    static async getAuthorizeInfo(clientId, redirectUri, scope, state) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/oauth/authorize/info`,
            query: {
                'client_id': clientId,
                'redirect_uri': redirectUri,
                'scope': scope,
                'state': state,
            },
        });
        return result.body;
    }
    /**
     * 创建机器人并生成授权码
     * 创建机器人并为页面授权，支持两种模式：
     * 1. 直接模式：直接创建机器人并返回机器人信息
     * 2. OAuth2模式：生成授权码并重定向到第三方应用
     *
     * @param requestBody
     * @returns any 直接模式 - 创建成功
     * @throws ApiError
     */
    static async createAuthorizationCode(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/oauth/authorizationCode`,
            body: requestBody,
            errors: {
                302: `OAuth模式 - 重定向到第三方应用`,
            },
        });
        return result.body;
    }
    /**
     * 获取机器人Token
     * 获取机器人的访问令牌，仅机器人创建者可以获取
     * @param botId 机器人ID
     * @returns any 获取成功
     * @throws ApiError
     */
    static async getBotToken(botId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/bots/${botId}/token`,
        });
        return result.body;
    }
    /**
     * 删除机器人
     * 删除指定的机器人，仅机器人创建者或空间管理员可以删除
     * @param botId 机器人ID
     * @returns any 删除成功
     * @throws ApiError
     */
    static async deleteBot(botId) {
        const result = await (0, request_1.request)({
            method: 'DELETE',
            path: `/bots/${botId}`,
        });
        return result.body;
    }
    /**
     * 获取机器人可访问页面
     * 获取机器人有权限访问的页面列表
     * @param botId 机器人ID
     * @returns any 获取成功
     * @throws ApiError
     */
    static async getBotPages(botId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/bots/${botId}/pages`,
        });
        return result.body;
    }
    /**
     * 更新机器人页面权限
     * 为机器人添加或移除页面访问权限
     * @param botId 机器人ID
     * @param requestBody
     * @returns any 更新成功
     * @throws ApiError
     */
    static async updateBotPages(botId, requestBody) {
        const result = await (0, request_1.request)({
            method: 'PATCH',
            path: `/bots/${botId}/pages`,
            body: requestBody,
        });
        return result.body;
    }
}
exports.IntegrationService = IntegrationService;
